/* eslint-disable */
// This is probably not used.

import React, { Fragment, useEffect, useState } from "react";

import Modal from "./Modal";
import HTML from "./HTML";

import { strings } from "../util/i18n";
import makeRestRequest from "../util/restReq";

const { request } = makeRestRequest();

export default (props) => {
  // plenty of props for future development
  const { hasVariations, id, type, wrapper } = props;
  const [quantity, setQuantity] = useState(1);
  const [modal, setModalData] = useState(null);

  const showErrorModal = (content) => {
    setModalData({
      contentLabel: "Error",
      content: (
        <>
          <h3>Error</h3>

          <HTML>{content}</HTML>
        </>
      ),
    });
  };

  const showPromptModal = (content) => {
    setModalData({
      contentLabel: "Prompt",
      content: (
        <>
          <HTML>{content}</HTML>
        </>
      ),
    });
  };

  const makeAddToCart = (listing) => {
    const form = listing.querySelector("form");

    return async (e) => {
      // e.preventDefault();

      window.scrollTo({
        top: 0,
        left: 0,
        // behavior: 'smooth',
      });

      const body = {
        product_id: id,
        quantity,
        return_cart: true,
        cart_item_data: {},
      };

      if (hasVariations) {
        const variation_id = parseInt(
          form.querySelector('[name="variation_id"]').value,
          10
        );
        const variationEls = Array.from(
          form.querySelectorAll(".variations select")
        );
        const variations = variationEls.reduce((acc, select) => {
          // WooCommerce works completely backwards in this regard.
          // const name = select.getAttribute('name')
          // const value = select.value

          const label = select.previousElementSibling.innerText;
          const value = select.selectedOptions[0].innerText;

          acc[label] = value;

          return acc;
        }, {});

        const variationsWithDefaultValues = variationEls.reduce((acc, el) => {
          // const { value } = el
          const value = el.selectedOptions[0].innerText;
          const defaults = ["", "Default", "Valitse"];

          if (defaults.includes(value)) {
            acc.push(el);
          }

          return acc;
        }, []);

        console.log(
          variationsWithDefaultValues,
          variationsWithDefaultValues.length,
          variation_id
        );

        if (variationsWithDefaultValues.length) {
          if (!confirm(strings.variationConfirmPrompt)) {
            return;
          }
        }

        body.variation_id = variation_id;
        body.variation = variations;
      }

      if (type === "accessory") {
        const subscriptionInput = form.querySelector(
          '[name="add-product-to-subscription"]'
        );

        if (subscriptionInput) {
          const id = subscriptionInput.value;
          const { value } = form.querySelector(
            `[name="convert_to_sub_${id}"]`
          ) || { value: null };

          if (value !== "0") {
            // The value flows down correctly but then the plugin nukes the value and sets it to false... Must be set manually...
            // body.cart_item_data.wcsatt_data = {
            //   active_subscription_scheme: value,
            // }

            body.cart_item_data.subscription_plan = value;
          }
        }
      }

      try {
        const { data, status } = await request("cocart/v1/add-item", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
          // body: new FormData(form)
        });

        if (status !== 200) {
          throw data;
        }

        window.postMessage(
          {
            source: "FloatingBar",
            action: "addToCart",
            cart: data,
          },
          window.location.origin
        );
      } catch (e) {
        if (e instanceof Error) {
          console.error(e);
        } else {
          const { message } = e;

          message && alert(message);
        }
      }
    };
  };

  const makePriceUpdater = (listing) => {
    const priceContainer = listing.querySelector(
      ".floating-bar__wrapper .price-container .price"
    );

    return async (e) => {
      if (!hasVariations) {
        // Price does not change
        return;
      }

      await new Promise((resolve) => setTimeout(resolve, 1)); // Delay for 1ms, the variation script runs in the same "tick" and the value is not ready to be read yet

      const variationId = parseInt(
        listing.querySelector('[name="variation_id"]').value,
        10
      );
      const variationsEl = listing.querySelector("form.variations_form");
      const variations = JSON.parse(
        variationsEl.getAttribute("data-product_variations")
      );
      const currentVariation = variationId
        ? variations.find((variation) => variation.variation_id === variationId)
        : false;

      if (currentVariation) {
        const { price_html } = currentVariation;

        priceContainer.innerHTML = price_html;
        // console.log(currentVariation)
      }
    };
  };

  const makeFormUpdater = (listing) => {
    const quantity = listing.querySelector("input.qty");

    return (e) => {
      const { value } = e.target;

      quantity.value = value;
      setQuantity(value);
    };
  };

  useEffect(() => {
    const { current } = wrapper;

    if (current) {
      const listing = current.closest(".single-product-listing");
      const quantity = current.querySelector("input.qty");
      const atc = current.querySelector(".add-to-cart");
      const variationSelects = Array.from(
        listing.querySelectorAll(".variations select")
      );

      const formUpdater = makeFormUpdater(listing);
      const addToCart = makeAddToCart(listing);
      const priceUpdater = makePriceUpdater(listing);

      atc.addEventListener("click", addToCart);
      quantity.addEventListener("change", formUpdater);

      variationSelects.forEach((select) =>
        select.addEventListener("change", priceUpdater)
      );

      return () => {
        atc.removeEventListener("click", addToCart);
        quantity.removeEventListener("change", formUpdater);
        variationSelects.forEach((select) =>
          select.removeEventListener("change", priceUpdater)
        );
      };
    }
  }, [wrapper]);

  return <>{props.children}</>;
};
